import React from "react";
import "./Button.scss";
import CircularProgress from "@mui/material/CircularProgress";

const Button = (props) => {
	return (
		<button
			className={props.className ? props.className : "button cp"}
			onClick={props.onClick}
			disabled={props.loader}
			style={props.style ? props.style : { cursor: "pointer" }}
		>
			{props.loader ? (
				<CircularProgress size="20px" color="inherit" />
			) : (
				<>
					<div
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							fontSize: props.src && "12px",
						}}
					>
						<div>
							{props.src && <img height="20px" width="20px" src={props.src} />}
							{props.icon && props.icon}
						</div>
						<div
							style={{
								marginLeft: props.icon && "4px",
								marginTop: props.icon && "-2px",
							}}
						>
							{props.text}
						</div>
						{props.pic && (
							<div style={{ marginTop: 3, paddingLeft: 3 }}>
								<img height="17px" width="17px" src={props.pic} />
							</div>
						)}
					</div>
				</>
			)}
		</button>
	);
};
export default Button;
